// extracted by mini-css-extract-plugin
module.exports = {"hosted-wrapper":"hosted_hosted-wrapper__CM8AW"};